import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

export default function LearnMoreIntro() {
	return (
		<>
			<Paper elevation={3} sx={{ p: 2 }}>
				<h3>Droughts in Vermont</h3>
				<p>"Droughts followed by flooding in the same year is also a characteristic of Vermont, 
					a pattern which has not changed over the last 100 years. For example, this flip-flop was 
					observed in 1927 ... (where the November floods remain the flood of record for Northern 
					Vermont) and more recently in August 2011 (where the flooding due to Tropical Storm Irene 
					stands as the flood of record for Southern Vermont). The August 2011 drought was an example 
					of a new type of drought called a flash drought, which is now observed more frequently in 
					Vermont. Flash droughts, as their name suggests, develop very quickly (weeks), typically in 
					the spring/summer months, where the lack of precipitation and decreased soil moisture is 
					often exacerbated by high daytime temperatures and low relative humidities in the air.” 
					- Dupigny-Giroux et al., 2021</p> 
			</Paper>

			<Typography
				variant="body1"
				sx={{ p:1, mx:2, border:"1pt solid gray", backgroundColor:"#f2f2f2" }}
			>
				Read more on pages 28-33 of 
				the <a href="https://outside.vermont.gov/agency/anr/climatecouncil/Shared%20Documents/Initial%20Climate%20Action%20Plan%20-%20Final%20-%2012-1-21.pdf" rel="noopener noreferer">
				2021 Initial Climate Action Plan for Vermont</a>.
			</Typography>
	   </>
	);
} 